export default __webpack_public_path__ + "static/media/Privacy Policy.62bfb778.pdf";